/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { createContext } from 'preact';
import { TabBarProps } from './TabBar';
import { MutableRefObject } from 'preact/compat';

type TabBarContextProps<K extends string | number> = Pick<
  TabBarProps<K>,
  'layout' | 'selection' | 'onSelectionChange'
> & {
  currentKey?: K;
  showFocusRing: boolean;
  isActiveElement: () => boolean;
  isFirstItemRendered?: MutableRefObject<boolean>;
};
/**
 * Context used to pass TabBar information without having to pass it to TabBar children props.
 * We want to communicate information down to any interested TabBar item children.
 */

const TabBarContext = createContext<TabBarContextProps<string | number>>(null!);

export { TabBarContext };
